import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateJobPayloadInterface } from "./dto";
import { db } from "../../firebase/firebase";
import { doc, updateDoc, getDoc, Timestamp } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";

import cleanData from "utils/cleanPayloadForFirebase";

/**
 * Updates a job in Firestore.
 */
const updateJob = async ({
  id,
  job,
}: UpdateJobPayloadInterface): Promise<void> => {
  try {
    const jobRef = doc(db, "jobs", id);

    const existingDoc = await getDoc(jobRef);
    if (!existingDoc.exists()) {
      throw new Error("Job not found");
    }

    const deadlineAt = job.deadlineAt
      ? Timestamp.fromDate(job.deadlineAt.toDate())
      : "";

    await updateDoc(jobRef, cleanData({ ...job, deadlineAt: deadlineAt }));
  } catch (error) {
    console.error("Error updating job:", error);
    throw error;
  }
};

/**
 * React Query hook for updating a job.
 */
export const useUpdateJob = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateJob,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.JOBS] });
    },
  });
};
